exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fp_opt_subtitle{color:#707070;font-size:1.5em;font-weight:700}", ""]);

// exports
